"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyMfaCode = exports.verifyEmail = exports.updatePassword = exports.recoverPassword = exports.logout = exports.getToken = exports.getMFASettings = exports.getCognitoUser = exports.enableMFA = exports.disableMFA = exports.confirmPassword = exports.confirMFA = exports.changePassword = exports.authenticate = void 0;
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _UserPool = _interopRequireWildcard(require("./UserPool"));
var _model = require("../model");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var toCognitoError = function toCognitoError(err, defaultCode) {
  if (err['code']) {
    return new _model.CognitoError(err['code'], err);
  }
  return new _model.CognitoError(defaultCode, err);
};
var getCognitoUser = exports.getCognitoUser = function getCognitoUser() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var user;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          user = _UserPool["default"].getCurrentUser();
          if (!user) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            user.getSession(function (err, session) {
              if (session) {
                resolve(session);
              } else if (err) {
                reject(toCognitoError(err, 'CognitoUser'));
              } else {
                reject(toCognitoError({}, 'SessionNotAvailable'));
              }
            });
          }));
        case 3:
          throw toCognitoError({}, 'NoSession');
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var getToken = exports.getToken = function getToken() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var user, idToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getCognitoUser();
        case 2:
          user = _context2.sent;
          idToken = user.getIdToken();
          return _context2.abrupt("return", idToken.getJwtToken());
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
var getCallbacks = function getCallbacks(cognitoUser, resolve, reject) {
  return {
    onSuccess: function onSuccess(cognitoUserSession) {
      resolve({
        name: 'success',
        cognitoUserSession: cognitoUserSession
      });
    },
    onFailure: function onFailure(err) {
      var _a;
      if (err['name'] === 'PasswordResetRequiredException') {
        var user = (_a = _UserPool["default"].getCurrentUser()) !== null && _a !== void 0 ? _a : cognitoUser;
        resolve({
          name: 'confirm_password',
          cognitoUser: user
        });
      } else {
        reject(toCognitoError(err, 'GeneralFailure'));
      }
    },
    newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
      resolve({
        name: 'update_password',
        cognitoUser: cognitoUser,
        userAttributes: userAttributes,
        requiredAttributes: requiredAttributes
      });
    },
    mfaRequired: function mfaRequired() {
      return resolve({
        name: 'required_2fa'
      });
    },
    mfaSetup: function mfaSetup() {
      return resolve({
        name: 'setup_2fa'
      });
    },
    totpRequired: function totpRequired(challengeName, challengeParameters) {
      var _a;
      if (challengeName === 'SOFTWARE_TOKEN_MFA') {
        var user = (_a = _UserPool["default"].getCurrentUser()) !== null && _a !== void 0 ? _a : cognitoUser;
        resolve({
          name: 'required_2fa',
          cognitoUser: user
        });
      } else {
        reject(toCognitoError(challengeParameters, 'totpRequired'));
      }
    },
    customChallenge: function customChallenge(challengeParameters) {
      reject(toCognitoError(challengeParameters, 'customChallenge'));
    }
  };
};
var authenticate = exports.authenticate = function authenticate(username, password) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var cognitoUser, authDetails;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          cognitoUser = new _amazonCognitoIdentityJs.CognitoUser({
            Username: username,
            Pool: _UserPool["default"],
            Storage: _UserPool.storage
          });
          authDetails = new _amazonCognitoIdentityJs.AuthenticationDetails({
            Username: username,
            Password: password
          });
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            cognitoUser.authenticateUser(authDetails, getCallbacks(cognitoUser, resolve, reject));
          }));
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
var updatePassword = exports.updatePassword = function updatePassword(cognitoUser, password, userAttributes) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            cognitoUser.completeNewPasswordChallenge(password, userAttributes, getCallbacks(cognitoUser, resolve, reject));
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
var confirmPassword = exports.confirmPassword = function confirmPassword(cognitoUser, verificationCode, password) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            cognitoUser.confirmPassword(verificationCode, password, {
              onSuccess: function onSuccess(success) {
                resolve(success);
              },
              onFailure: function onFailure(err) {
                reject(toCognitoError(err, 'ConfirmPassword'));
              }
            });
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
var recoverPassword = exports.recoverPassword = function recoverPassword(username) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var cognitoUser;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          cognitoUser = new _amazonCognitoIdentityJs.CognitoUser({
            Username: username,
            Pool: _UserPool["default"],
            Storage: _UserPool.storage
          });
          return _context6.abrupt("return", new Promise(function (resolve, reject) {
            cognitoUser.forgotPassword({
              onSuccess: function onSuccess(data) {
                resolve({
                  data: data,
                  cognitoUser: cognitoUser
                });
              },
              onFailure: function onFailure(err) {
                reject(toCognitoError(err, 'RecoverPassword'));
              }
            });
          }));
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
};
var logout = exports.logout = function logout(callback) {
  var user = _UserPool["default"].getCurrentUser();
  if (user) {
    user.signOut(callback);
  }
};
var verifyEmail = exports.verifyEmail = function verifyEmail(code) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var user;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          user = _UserPool["default"].getCurrentUser();
          if (!(user != null)) {
            _context7.next = 3;
            break;
          }
          return _context7.abrupt("return", new Promise(function (resolve, reject) {
            user.getSession(function (err, session) {
              if (session) {
                user.verifyAttribute('email', code, {
                  onSuccess: function onSuccess(data) {
                    resolve();
                  },
                  onFailure: function onFailure(err) {
                    reject(err);
                  }
                });
              } else if (err) {
                reject(toCognitoError(err, 'VerifyEmail'));
              } else {
                reject(toCognitoError({}, 'SessionNotAvailable'));
              }
            });
          }));
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
};
var changePassword = exports.changePassword = function changePassword(oldPassword, newPassword) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", new Promise(function (resolve, reject) {
            var user = _UserPool["default"].getCurrentUser();
            if (user) {
              user.getSession(function (err, session) {
                if (session) {
                  user.changePassword(oldPassword, newPassword, function (err, result) {
                    if (err) {
                      reject(err);
                      return;
                    }
                    resolve(result);
                  });
                } else if (err) {
                  reject(toCognitoError(err, 'ChangePassword'));
                } else {
                  reject(toCognitoError({}, 'SessionNotAvailable'));
                }
              });
            } else {
              reject(toCognitoError({}, 'SessionNotAvailable'));
            }
          }));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
};
var getMFASettings = exports.getMFASettings = function getMFASettings() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", new Promise(function (resolve, reject) {
            var user = _UserPool["default"].getCurrentUser();
            if (user) {
              user.getSession(function (err, session) {
                if (session) {
                  user.getUserData(function (err, data) {
                    if (err) {
                      reject(err);
                      return;
                    }
                    resolve({
                      status: (data === null || data === void 0 ? void 0 : data.PreferredMfaSetting) === 'SOFTWARE_TOKEN_MFA' && (data === null || data === void 0 ? void 0 : data.UserMFASettingList) && (data === null || data === void 0 ? void 0 : data.UserMFASettingList.indexOf('SOFTWARE_TOKEN_MFA')) > -1 ? 'active' : 'optional_pending'
                    });
                  }, {
                    bypassCache: true
                  });
                } else if (err) {
                  reject(toCognitoError(err, 'MfaSettings'));
                } else {
                  reject(toCognitoError({}, 'SessionNotAvailable'));
                }
              });
            } else {
              reject(toCognitoError({}, 'SessionNotAvailable'));
            }
          }));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
};
var enableMFA = exports.enableMFA = function enableMFA(email) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", new Promise(function (resolve, reject) {
            var user = _UserPool["default"].getCurrentUser();
            if (user) {
              user.getSession(function (err, session) {
                if (session) {
                  user.associateSoftwareToken({
                    associateSecretCode: function associateSecretCode(secretCode) {
                      var appName = process.env.REACT_APP_2FA_APP_NAME;
                      var value = encodeURI("otpauth://totp/".concat(appName, " (").concat(email, ")?secret=").concat(secretCode, "&issuer=").concat(appName));
                      var qrUrl = "https://quickchart.io/qr?size=200&text=".concat(value);
                      resolve({
                        secretCode: secretCode,
                        status: 'not_verified',
                        qrUrl: qrUrl
                      });
                    },
                    onFailure: function onFailure(err) {
                      reject(toCognitoError(err, 'AssociateToken'));
                    }
                  });
                } else if (err) {
                  reject(toCognitoError(err, 'EnableMfa'));
                } else {
                  reject(toCognitoError({}, 'SessionNotAvailable'));
                }
              });
            } else {
              reject(toCognitoError({}, 'SessionNotAvailable'));
            }
          }));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
};
var confirMFA = exports.confirMFA = function confirMFA(totpCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", new Promise(function (resolve, reject) {
            var user = _UserPool["default"].getCurrentUser();
            if (user) {
              user.getSession(function (err, session) {
                if (session) {
                  user.verifySoftwareToken(totpCode, '', {
                    onSuccess: function onSuccess(internalSession) {
                      user.setUserMfaPreference(null, {
                        Enabled: true,
                        PreferredMfa: true
                      }, function (err, result) {
                        if (err) {
                          reject(toCognitoError(err, 'SetMfaPreference'));
                        } else {
                          resolve({
                            status: 'active'
                          });
                        }
                      });
                    },
                    onFailure: function onFailure(err) {
                      reject(toCognitoError(err, 'VerifyToken'));
                    }
                  });
                } else if (err) {
                  reject(toCognitoError(err, 'ConfirmMFA'));
                } else {
                  reject(toCognitoError({}, 'SessionNotAvailable'));
                }
              });
            } else {
              reject(toCognitoError({}, 'SessionNotAvailable'));
            }
          }));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
};
var disableMFA = exports.disableMFA = function disableMFA(totpCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", new Promise(function (resolve, reject) {
            var user = _UserPool["default"].getCurrentUser();
            if (user) {
              user.getSession(function (err, session) {
                if (session) {
                  user.setUserMfaPreference(null, {
                    Enabled: false,
                    PreferredMfa: false
                  }, function (err, result) {
                    if (err) {
                      reject(toCognitoError(err, 'SetMfaPreference'));
                    } else {
                      resolve({
                        status: 'optional_pending'
                      });
                    }
                  });
                } else if (err) {
                  reject(toCognitoError(err, 'DisableMFA'));
                } else {
                  reject(toCognitoError({}, 'SessionNotAvailable'));
                }
              });
            } else {
              reject(toCognitoError({}, 'SessionNotAvailable'));
            }
          }));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
};
var verifyMfaCode = exports.verifyMfaCode = function verifyMfaCode(code, cognitoUser) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", new Promise(function (resolve, reject) {
            cognitoUser.sendMFACode(code, {
              onSuccess: function onSuccess(session, userConfirmationNecessary) {
                resolve('success');
              },
              onFailure: function onFailure(err) {
                reject(toCognitoError(err, 'VerifyMfaCode'));
              }
            }, 'SOFTWARE_TOKEN_MFA');
          }));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
};